export const iconFontAwesomeSocialThumbsDown = (
	<i className="fa-solid fa-thumbs-down"></i>
);
